import { useApiClient } from '@/composables/useApiClient'

export const state = () => ({
  branchComments: {},
  branchModalComments: {},
  productComments: {},
  productModalComments: {},
})

export const getters = {
  branchComments: state => state.branchComments,
  branchModalComments: state => state.branchModalComments,
  productComments: state => state.productComments,
  productModalComments: state => state.productModalComments,
}

export const actions = {
  async getBranchComments({ commit }, { bid, query = '', from = 'default', action = '' }) {
    const url = `/pub/branch/${bid}/comments?${query}`
    const res = await useApiClient().$get(url)
    if (res.code === 0) {
      switch (from) {
        case 'commentsModal':
          if (action === '') {
            commit('CLEAN_BRANCH_MODAL_COMMENTS')
          }
          commit('SET_BRANCH_MODAL_COMMENTS', res.data || {})
          break
        default:
          commit('SET_BRANCH_COMMENTS', res.data || {})
          break
      }
      return res.data || []
    }
  },
  async getProductComments({ commit }, { pid, query = '', from = 'default', action = '' }) {
    // params {pid, start, size, sortby}
    const url = `/pub/product/${pid}/comments?${query}`
    const res = await useApiClient().$get(url)
    if (res.code === 0) {
      switch (from) {
        case 'commentsModal':
          if (action === '') {
            commit('CLEAN_PRODUCT_MODAL_COMMENTS')
          }
          commit('SET_PRODUCT_MODAL_COMMENTS', res.data || {})
          break
        default:
          commit('SET_PRODUCT_COMMENTS', res.data || {})
          break
      }
      return res.data
    }
  },
  async setCommentLikeStatus({ dispatch }, { commentID }) {
    const url = `/review/${commentID}/like`
    const res = await useApiClient().$put(url)
    if (res.code === 0) {
      return res
    }
  },
  async setCommentUnlikeStatus({ dispatch }, { commentID }) {
    const url = `/review/${commentID}/unlike`
    const res = await useApiClient().$delete(url)
    if (res.code === 0) {
      return res
    }
  },
}

export const mutations = {
  CLEAN_BRANCH_MODAL_COMMENTS(state) {
    state.branchModalComments = Object.assign({})
  },
  SET_BRANCH_COMMENTS(state, comments) {
    state.branchComments = comments
  },
  SET_BRANCH_MODAL_COMMENTS(state, comments) {
    if (Object.entries(state.branchModalComments).length === 0) {
      state.branchModalComments = comments
    } else {
      comments.comment = state.branchModalComments.comment.concat(comments.comment)
      state.branchModalComments = Object.assign({}, comments)
    }
  },
  CLEAN_PRODUCT_MODAL_COMMENTS(state) {
    state.productModalComments = Object.assign({})
  },
  SET_PRODUCT_COMMENTS(state, comments) {
    state.productComments = comments
  },
  SET_PRODUCT_MODAL_COMMENTS(state, comments) {
    if (Object.entries(state.productModalComments).length === 0) {
      state.productModalComments = comments
    } else {
      comments.comment = state.productModalComments.comment.concat(comments.comment)
      state.productModalComments = Object.assign({}, comments)
    }
  },
}
